import * as React from "react";
import { useNavigate } from "react-router-dom";
import Routes from "routing/Routes";
import usePluginEntities from "hooks/usePluginEntities";
import { Row, Col, Button, Label } from "components/bootstrap";
import useScopePermissions from "hooks/useScopePermissions";
import { SummaryRow, Title, Value } from "./caches/SummaryComponents.styled";
const Cache = ({ cache, noEdit = false }) => {
  const { loadingScopePermissions, scopePermissions } = useScopePermissions(cache);
  const plugin = usePluginEntities("lookupTableCaches").find((p) => {
    var _a;
    return p.type === ((_a = cache.config) == null ? void 0 : _a.type);
  });
  const navigate = useNavigate();
  const canEdit = !noEdit && !loadingScopePermissions && (scopePermissions == null ? void 0 : scopePermissions.is_mutable);
  if (!plugin) {
    return /* @__PURE__ */ React.createElement("p", null, "Unknown cache type ", cache.config.type, ". Is the plugin missing?");
  }
  const handleEdit = () => {
    navigate(Routes.SYSTEM.LOOKUPTABLES.CACHES.edit(cache.name));
  };
  return /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" } }, /* @__PURE__ */ React.createElement(Label, null, plugin.displayName), canEdit && /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: handleEdit, role: "button", name: "edit_square" }, "Edit")), /* @__PURE__ */ React.createElement(SummaryRow, null, /* @__PURE__ */ React.createElement(Title, null, "Description:"), /* @__PURE__ */ React.createElement(Value, null, cache.description || /* @__PURE__ */ React.createElement("em", null, "No description."))), /* @__PURE__ */ React.createElement("h4", null, "Configuration"), /* @__PURE__ */ React.createElement("div", null, React.createElement(plugin.summaryComponent, { cache }))));
};
export default Cache;
